import React from 'react';
import { Home, Layers, Newspaper, Megaphone, HeartHandshake } from 'lucide-react';
import { LanguageCode } from '../types';
import { translations } from '../i18n/translations';

interface BottomMobileNavProps {
  currentLang: LanguageCode;
  activeTab?: string;
  currentTab?: string;
  onNavClick: (tab: string) => void;
}

export const BottomMobileNav: React.FC<BottomMobileNavProps> = ({
  currentLang,
  activeTab,
  currentTab,
  onNavClick,
}) => {
  const t = translations[currentLang];
  const currentActiveTab = activeTab || currentTab || 'home';

  return (
    <div className="fixed bottom-0 left-0 right-0 h-[90px] z-40 bg-[#0B1426]/95 backdrop-blur-xl border-t border-[#38BDF8]/30 px-2 sm:px-6 flex items-center justify-around select-none shadow-[0_-5px_25px_rgba(0,0,0,0.5)]">
      {/* SOL 1: Faaliyetler */}
      <button
        onClick={() => onNavClick('activities')}
        className={`flex flex-col items-center justify-center w-16 py-1 transition-all duration-300 cursor-pointer ${
          currentActiveTab === 'activities'
            ? 'text-[#38BDF8] scale-110 font-black drop-shadow-[0_0_10px_rgba(56,189,248,0.8)]'
            : 'text-gray-400 hover:text-[#7DD3FC]'
        }`}
      >
        <Layers className={`w-5 h-5 mb-1 ${currentActiveTab === 'activities' ? 'stroke-[2.5]' : 'stroke-2'}`} />
        <span className="text-[10px] font-medium tracking-tight truncate max-w-full">
          {t.activities}
        </span>
      </button>

      {/* SOL 2: Haberler */}
      <button
        onClick={() => onNavClick('news')}
        className={`flex flex-col items-center justify-center w-16 py-1 transition-all duration-300 cursor-pointer ${
          currentActiveTab === 'news'
            ? 'text-[#38BDF8] scale-110 font-black drop-shadow-[0_0_10px_rgba(56,189,248,0.8)]'
            : 'text-gray-400 hover:text-[#7DD3FC]'
        }`}
      >
        <Newspaper className={`w-5 h-5 mb-1 ${currentActiveTab === 'news' ? 'stroke-[2.5]' : 'stroke-2'}`} />
        <span className="text-[10px] font-medium tracking-tight truncate max-w-full">
          {t.news}
        </span>
      </button>

      {/* ORTA: ANA SAYFA */}
      <div className="relative -top-5 flex flex-col items-center justify-center">
        <button
          onClick={() => onNavClick('home')}
          className={`diamond-btn group ${
            currentActiveTab === 'home'
              ? 'border-[#A5F3FC] bg-[#38BDF8] shadow-[0_0_30px_rgba(56,189,248,0.9)] scale-105'
              : 'border-[#38BDF8] bg-[#132238] shadow-[0_0_15px_rgba(56,189,248,0.4)]'
          }`}
          title={t.home}
        >
          <div className={`diamond-btn-content transition-colors ${
            currentActiveTab === 'home' ? 'text-[#0B1426]' : 'text-[#38BDF8] group-hover:text-[#A5F3FC]'
          }`}>
            <Home className="w-6 h-6 stroke-[2.2]" />
          </div>
        </button>
        <span className="text-[10px] font-bold tracking-wider text-[#38BDF8] uppercase mt-1 drop-shadow-[0_0_5px_rgba(56,189,248,0.5)]">
          {t.home}
        </span>
      </div>

      {/* SAĞ 1: Reklamlar */}
      <button
        onClick={() => onNavClick('ads')}
        className={`flex flex-col items-center justify-center w-16 py-1 transition-all duration-300 cursor-pointer ${
          currentActiveTab === 'ads' || currentActiveTab === 'reklamlar'
            ? 'text-[#D4AF37] scale-110 font-black drop-shadow-[0_0_10px_rgba(212,175,55,0.8)]'
            : 'text-gray-400 hover:text-[#F3E5AB]'
        }`}
      >
        <Megaphone className={`w-5 h-5 mb-1 ${currentActiveTab === 'ads' || currentActiveTab === 'reklamlar' ? 'stroke-[2.5] text-[#D4AF37]' : 'stroke-2'}`} />
        <span className="text-[10px] font-medium tracking-tight truncate max-w-full">
          {t.ads || 'Reklamlar'}
        </span>
      </button>

      {/* SAĞ 2: Bağış Yap */}
      <button
        onClick={() => onNavClick('donate')}
        className={`flex flex-col items-center justify-center w-16 py-1 transition-all duration-300 cursor-pointer ${
          currentActiveTab === 'donate'
            ? 'text-red-400 scale-110 font-black drop-shadow-[0_0_12px_rgba(239,68,68,0.9)]'
            : 'text-red-400/80 hover:text-red-300'
        }`}
      >
        <HeartHandshake className={`w-5 h-5 mb-1 ${currentActiveTab === 'donate' ? 'stroke-[2.5] text-red-500' : 'stroke-2 text-red-400'}`} />
        <span className="text-[10px] font-black tracking-tight truncate max-w-full text-red-400">
          {t.donate}
        </span>
      </button>
    </div>
  );
};
